"use client";

var __jsx = React.createElement;
import React, { createContext, useContext, useState } from "react";
const ActiveContentContext = /*#__PURE__*/createContext(null);
export const ActiveContentProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: activeContent,
    1: setActiveContent
  } = useState();
  const {
    0: isOverlay,
    1: setIsOverlay
  } = useState(false);
  const changeActiveContent = (content, isOverlay) => {
    setActiveContent(content);
    setIsOverlay(isOverlay !== null && isOverlay !== void 0 ? isOverlay : false);
  };
  const setActiveContentToDefault = origin => {
    setActiveContent(undefined);
  };
  return __jsx(ActiveContentContext.Provider, {
    value: {
      activeContent,
      changeActiveContent,
      setActiveContentToDefault,
      isOverlay
    }
  }, children);
};
export const useActiveContent = () => {
  const context = useContext(ActiveContentContext);
  if (context === null) {
    throw new Error("useActiveContent must be used within a ActiveContentProvider");
  }
  return context;
};